"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.SearchVehicleVrnAndDetailsStepDefinition = void 0;
const WidgetFormStepPluginDefinition_1 = require("../../../../Plugin/WidgetStep/WidgetFormStepPluginDefinition");
const RepositoryTypes_1 = require("../../../../Enum/RepositoryTypes");
const TemplateTypes_1 = require("../../../../Enum/TemplateTypes");
const StepTypes_1 = require("../../../../Enum/StepTypes");
const WidgetEvents_1 = require("auto-widget-framework/src/Widget/EventDefinition/WidgetEvents");
const WidgetFormStepBase_1 = require("../../../../Plugin/WidgetStep/WidgetFormStepBase");
const EndpointError_1 = require("../../../../Error/EndpointError");
const VehicleOptionType_1 = require("../../../../Enum/VehicleOptionType");
const VehicleOption_1 = require("../../../../Model/VehicleOption");
const Vehicle_1 = require("../../../../Model/Vehicle");
const configs_1 = require("../../../../configs/configs");
const BackEndUnMapperService_1 = require("../../../../Service/BackEndUnMapperService");
const SearchVehicleVrnAndDetailsForm_1 = require("../FormHandler/SearchVehicleVrnAndDetailsForm");
const InchcapeInternalEvents_1 = require("../../../../Enum/InchcapeInternalEvents");
class SearchVehicleVrnAndDetailsStep extends WidgetFormStepBase_1.default {
    constructor(definition, widgetConfig, state, eventContext, ractiveWrapper, formHandlerProvider, repoFactory, returnLinkService) {
        super(definition, widgetConfig, state, eventContext, ractiveWrapper, formHandlerProvider);
        this.stateOptions = [];
        this.fieldNames = {
            vrm: "registration_number"
        };
        this.optionsInOrder = [
            VehicleOptionType_1.VehicleOptionType.STATE,
            VehicleOptionType_1.VehicleOptionType.MANUFACTURER,
            VehicleOptionType_1.VehicleOptionType.MODEL,
            VehicleOptionType_1.VehicleOptionType.BUILD_YEAR,
            VehicleOptionType_1.VehicleOptionType.BODY,
            VehicleOptionType_1.VehicleOptionType.TRANSMISSION,
            VehicleOptionType_1.VehicleOptionType.FUEL,
            VehicleOptionType_1.VehicleOptionType.VARIANT
        ];
        this.optionsErrorLabels = ["state", "make", "model", "build year", "body style", "transmission", "fuel type", "variant"];
        this.vehicleRepo = repoFactory.create(RepositoryTypes_1.RepositoryTypes.VEHICLE, { config: this.widgetConfig });
        this.optionsRepo = repoFactory.create(RepositoryTypes_1.RepositoryTypes.VEHICLE_OPTIONS, { config: this.widgetConfig });
        this.returnLinkService = returnLinkService;
        configs_1.configs.addressState.forEach((residenceState) => {
            let stateOption = new VehicleOption_1.VehicleOption();
            stateOption.setId(residenceState.id).setLabel(residenceState.label);
            this.stateOptions.push(stateOption);
        });
    }
    /**
     * @inheritDoc
     * @see IContainerInjection
     */
    static create(definition, widgetConfig, state, eventContext, container) {
        return new this(definition, widgetConfig, state, eventContext, container.get("ractive_wrapper"), container.get("plugin.provider.form_handler"), container.get("factory.repository"), container.get("return_link"));
    }
    /**
     * @inheritDoc
     */
    getTemplate() {
        return this.widgetConfig.getTemplate(TemplateTypes_1.TemplateTypes.SEARCH_VEHICLE_VRN_AND_DETAILS).getTemplate();
    }
    /**
     * @inheritDoc
     */
    render() {
        let result = super.render();
        this.renderer.set("setSelectedOption", this.setSelectedOption.bind(this));
        return result;
    }
    /**
     * @inheritDoc
     */
    registerHandlers() {
        super.registerHandlers();
        let container = document.getElementById(this.widgetConfig.getContainerId());
        container.querySelector(configs_1.configs.elementIDs.vrm).addEventListener('blur', this.toggleVrmVerifier.bind(this));
        container.querySelector(configs_1.configs.elementIDs.vrm).addEventListener('focus', this.toggleVrmVerifier.bind(this));
        this.renderer.observe("vrm", (value) => {
            this.state.setVrm(value);
        });
        const variantOptions = this.state.getVehicleOptionType(VehicleOptionType_1.VehicleOptionType.VARIANT);
        let vehicleSearchPreloadRequired = this.state.getVehicleSearchPreloadRequired();
        if ((variantOptions && variantOptions.length > 0) || vehicleSearchPreloadRequired) {
            this.form.validateFormAndDisplaySubmit();
        }
    }
    /**
     * @inheritDoc
     */
    initialize() {
        return Promise.resolve().then(() => {
            this.container = document.getElementById(this.widgetConfig.getContainerId());
            this.state.setVehicleSearchPreloadRequired(true);
            this.state.setIncompleteInfo(false);
            this.state.setTriedVrm(false);
            if (this.state.getVehicleSearchPreloadRequired()) {
                let previousValuation = this.state.getValuation();
                if (previousValuation && previousValuation.getVrm()) {
                    return this.loadVehicleFullData();
                }
                else if (this.state.getVehicleOptionType(VehicleOptionType_1.VehicleOptionType.STATE)) {
                    return this.loadTillState();
                }
            }
        });
    }
    loadTillState() {
        let promises = [];
        for (let i = 0; i <= this.optionsInOrder.indexOf(VehicleOptionType_1.VehicleOptionType.STATE) + 1; i++) {
            promises.push(this.loadVehicleOptions(this.optionsInOrder[i]));
        }
        return Promise.all(promises);
    }
    loadVehicleFullData() {
        let previousValuation = this.state.getValuation();
        let vehicle = previousValuation.getVehicle();
        let vehicleHistory = vehicle.getVehicleHistory();
        if (vehicle && vehicleHistory) {
            this.state.setVrm(vehicle.getVrm());
            let backEndUnMapperService = new BackEndUnMapperService_1.BackEndUnMapperService();
            this.state.setVehicleOptionType(VehicleOptionType_1.VehicleOptionType.STATE, vehicleHistory.getRegistrationStatus().getRegistrationLocationCode());
            this.state.setVehicleOptionType(VehicleOptionType_1.VehicleOptionType.MANUFACTURER, vehicle.getManufacturerCode());
            this.state.setVehicleOptionType(VehicleOptionType_1.VehicleOptionType.MODEL, backEndUnMapperService.unMapModelCode(vehicle));
            this.state.setVehicleOptionType(VehicleOptionType_1.VehicleOptionType.BUILD_YEAR, vehicle.getBuildYearCode());
            this.state.setVehicleOptionType(VehicleOptionType_1.VehicleOptionType.BODY, vehicle.getBodyType());
            this.state.setVehicleOptionType(VehicleOptionType_1.VehicleOptionType.TRANSMISSION, vehicle.getTransmissionCode());
            this.state.setVehicleOptionType(VehicleOptionType_1.VehicleOptionType.FUEL, vehicle.getFuelTypeCode());
            this.state.setVehicleOptionType(VehicleOptionType_1.VehicleOptionType.VARIANT, vehicle.getModelVariantCode());
            let promises = [];
            for (let i = 0; i < this.optionsInOrder.length; i++) {
                promises.push(this.loadVehicleOptions(this.optionsInOrder[i]));
            }
            return Promise.all(promises);
        }
    }
    /**
     * @inheritDoc
     */
    submit(data) {
        this.state.setIsLoading(true);
        this.state.setIncompleteInfo(false);
        this.state.setVehicleSearchPreloadRequired(false);
        const vehicle = new Vehicle_1.default()
            .setVrm(data.vrm)
            .setModelCode(this.state.getVehicleOptionType(VehicleOptionType_1.VehicleOptionType.MODEL))
            .setModelVariantCode(this.state.getVehicleOptionType(VehicleOptionType_1.VehicleOptionType.VARIANT))
            .setRegistrationLocation(this.state.getVehicleOptionType(VehicleOptionType_1.VehicleOptionType.STATE));
        return this.vehicleRepo.create(vehicle)
            .then((vehicles) => {
            this.state.setVehicles(vehicles);
        })
            .then(() => {
            this.state.setIsLoading(false);
            this.eventContext.emit(InchcapeInternalEvents_1.InchcapeInternalEvents.SET_STEP, StepTypes_1.StepTypes.SELECT_VEHICLE);
        })
            .catch((error) => {
            this.state.setIsLoading(false);
            this.eventContext.emit(WidgetEvents_1.WidgetEvents.INTERNAL_ERROR, error);
        })
            .finally(() => this.state.setVrnOnlySearchFailed(false));
    }
    /**
     * @TODO: See if we still need this over the ractive observer.
     * @param event
     */
    toggleVrmVerifier(event) {
        const verifier = () => {
            const input = event.target;
            this.form.getFormValidator()
                .validateField(input.name, this.form.getValue(input.name))
                .then((errors) => this.togglePostVrmOptions(!errors));
        };
        if (this.vrmVerifierInterval) {
            verifier();
            clearInterval(this.vrmVerifierInterval);
            this.vrmVerifierInterval = null;
        }
        else {
            // Use intervals to check value in order to bypass the issue
            // of autocomplete selection not triggering change.
            this.vrmVerifierInterval = setInterval(verifier, 400);
        }
    }
    togglePostVrmOptions(show) {
        if (show) {
            this.state.setVehicleOptions(VehicleOptionType_1.VehicleOptionType.STATE, this.stateOptions);
            this.state.setCurrentOption(this.optionsErrorLabels[0]);
        }
        else {
            this.resetOptions();
            this.state.setVehicleOptionTypeLabel(VehicleOptionType_1.VehicleOptionType.STATE, '');
            this.state.setVehicleOptionType(VehicleOptionType_1.VehicleOptionType.STATE, '');
            this.form.getFormValidationRenderer()
                .removeForField('state');
        }
    }
    handleOptionsCallError(error, optionType) {
        if (EndpointError_1.default.is(error) && error.getResponseStatus() == "404") {
            this.state.setVehicleOptionTypeError(optionType, true);
            this.state.setErrorStatus(error.getResponseStatus());
        }
        else {
            // Reset the option to the not selected label. Note that '' is the value of that option.
            this.state.setVehicleOptionType(optionType, '');
            throw error;
        }
    }
    resetOptions(option = null) {
        this.state.setErrorStatus(false);
        let index = this.optionsInOrder.indexOf(option);
        for (let i = index + 1; i < this.optionsInOrder.length; i++) {
            this.state.setVehicleOptionType(this.optionsInOrder[i], "");
            this.state.setVehicleOptions(this.optionsInOrder[i], null);
        }
    }
    setSelectedOption(option) {
        this.state.setErrorStatus(false);
        this.state.setIncompleteInfo(false);
        let query = configs_1.configs.elementIDs[option];
        let selectedOption = this.container.querySelector(query).value;
        let index = this.optionsInOrder.indexOf(option);
        let nextOptionType = null;
        if (index < this.optionsInOrder.length) {
            nextOptionType = this.optionsInOrder[index + 1];
        }
        // The please select options have an value of empty string
        if (selectedOption !== '') {
            this.state.setVehicleOptionType(option, selectedOption);
            this.state.setVehicleOptionTypeLabel(option, this.getLabelForOption(option, selectedOption));
            // Reset the options that go after it
            if (nextOptionType) {
                this.resetOptions(option);
                this.loadVehicleOptions(nextOptionType);
            }
        }
    }
    loadVehicleOptions(typeToLoad) {
        let promise = null;
        switch (typeToLoad) {
            case VehicleOptionType_1.VehicleOptionType.STATE:
                this.state.setVehicleOptions(VehicleOptionType_1.VehicleOptionType.STATE, this.stateOptions);
                return Promise.resolve();
            case VehicleOptionType_1.VehicleOptionType.MANUFACTURER:
                promise = this.optionsRepo.getManufacturers();
                break;
            case VehicleOptionType_1.VehicleOptionType.MODEL:
                promise = this.optionsRepo.getModels(this.state.getVehicleOptionType(VehicleOptionType_1.VehicleOptionType.MANUFACTURER));
                break;
            case VehicleOptionType_1.VehicleOptionType.BUILD_YEAR:
                promise = this.optionsRepo.getBuildYears(this.state.getVehicleOptionType(VehicleOptionType_1.VehicleOptionType.MANUFACTURER), this.state.getVehicleOptionType(VehicleOptionType_1.VehicleOptionType.MODEL));
                break;
            case VehicleOptionType_1.VehicleOptionType.BODY:
                promise = this.optionsRepo.getBodyTypes(this.state.getVehicleOptionType(VehicleOptionType_1.VehicleOptionType.MANUFACTURER), this.state.getVehicleOptionType(VehicleOptionType_1.VehicleOptionType.MODEL), this.state.getVehicleOptionType(VehicleOptionType_1.VehicleOptionType.BUILD_YEAR));
                break;
            case VehicleOptionType_1.VehicleOptionType.TRANSMISSION:
                promise = this.optionsRepo.getTransmissions(this.state.getVehicleOptionType(VehicleOptionType_1.VehicleOptionType.MANUFACTURER), this.state.getVehicleOptionType(VehicleOptionType_1.VehicleOptionType.MODEL), this.state.getVehicleOptionType(VehicleOptionType_1.VehicleOptionType.BUILD_YEAR), this.state.getVehicleOptionType(VehicleOptionType_1.VehicleOptionType.BODY));
                break;
            case VehicleOptionType_1.VehicleOptionType.FUEL:
                promise = this.optionsRepo.getFuels(this.state.getVehicleOptionType(VehicleOptionType_1.VehicleOptionType.MANUFACTURER), this.state.getVehicleOptionType(VehicleOptionType_1.VehicleOptionType.MODEL), this.state.getVehicleOptionType(VehicleOptionType_1.VehicleOptionType.BUILD_YEAR), this.state.getVehicleOptionType(VehicleOptionType_1.VehicleOptionType.BODY), this.state.getVehicleOptionType(VehicleOptionType_1.VehicleOptionType.TRANSMISSION));
                break;
            case VehicleOptionType_1.VehicleOptionType.VARIANT:
                promise = this.optionsRepo.getVariants(this.state.getVehicleOptionType(VehicleOptionType_1.VehicleOptionType.MANUFACTURER), this.state.getVehicleOptionType(VehicleOptionType_1.VehicleOptionType.MODEL), this.state.getVehicleOptionType(VehicleOptionType_1.VehicleOptionType.BUILD_YEAR), this.state.getVehicleOptionType(VehicleOptionType_1.VehicleOptionType.BODY), this.state.getVehicleOptionType(VehicleOptionType_1.VehicleOptionType.TRANSMISSION), this.state.getVehicleOptionType(VehicleOptionType_1.VehicleOptionType.FUEL));
                break;
            default: console.warn("Attempting to load options for type that is not supported");
        }
        if (this.form && this.form.getFormElement()) {
            this.form.validateFormAndDisplaySubmit();
            this.form.disableForm();
        }
        this.state.setCurrentOption(this.optionsErrorLabels[this.optionsInOrder.indexOf(typeToLoad)]);
        if (promise) {
            this.state.setIsLoading(true);
            return promise.then((optionsList) => {
                if (optionsList.length === 0) {
                    //When no future values are available but the request comes as a 200 with [] as the response
                    this.state.setErrorStatus(404);
                }
                this.state.setVehicleOptionTypeError(typeToLoad, false);
                this.state.setVehicleOptions(typeToLoad, optionsList);
                this.state.setIsLoading(false);
                if (this.form && this.form.getFormElement()) {
                    this.form.initialize();
                }
            })
                .catch((error) => {
                this.state.setIsLoading(false);
                this.handleOptionsCallError(error, typeToLoad);
                this.eventContext.emit(WidgetEvents_1.WidgetEvents.INTERNAL_ERROR, error);
            })
                .finally(() => {
                if (this.form) {
                    this.form.enableForm();
                }
            });
        }
    }
    getLabelForOption(option, selectedOption) {
        let optionsList = this.state.getVehicleOptions(option);
        for (let i = 0; i < optionsList.length; i++) {
            if (optionsList[i].getId() === selectedOption) {
                return optionsList[i].getLabel();
            }
        }
    }
    /**
     * @inheritDoc
     */
    destroy() {
        super.destroy();
        return Promise.resolve().then(() => {
            clearInterval(this.vrmVerifierInterval);
        });
    }
}
exports.default = SearchVehicleVrnAndDetailsStep;
exports.SearchVehicleVrnAndDetailsStepDefinition = new WidgetFormStepPluginDefinition_1.default({
    id: StepTypes_1.StepTypes.SEARCH_VEHICLE_VRN_AND_DETAILS,
    progressIndex: 1,
    class: SearchVehicleVrnAndDetailsStep,
    form_id: SearchVehicleVrnAndDetailsForm_1.SearchVehicleVrnAndDetailsFormDefinition.getId(),
    linear: false
});
